import { createContext, type Dispatch, type SetStateAction } from 'react'

import { type CreateOrEditNAVOptionsState } from 'components/brokers/needs_attention/CreateOrEditNAVItem'

import { type getBrokersMissingPaymentsQueryKey } from '../hooks/useGetBrokersMissingPayments'

type ActionsVisibilityOverrideType = {
  silence: boolean
  resolve: boolean
  openInNewTab: boolean
}

export type NeedsAttentionContextType = {
  isNAVAdmin?: boolean,
  isNAVv2ToolingEnabled?: boolean
  getBrokersMissingPaymentsQueryKey: ReturnType<typeof getBrokersMissingPaymentsQueryKey>
  actionsVisibilityOverrides?: ActionsVisibilityOverrideType
  createOrEditNAVItemOptions: CreateOrEditNAVOptionsState
  setCreateOrEditNAVItemOptions: Dispatch<SetStateAction<CreateOrEditNAVOptionsState>>
}

const NeedsAttentionContext = createContext<NeedsAttentionContextType>({
  isNAVAdmin: false,
  isNAVv2ToolingEnabled: false,
  getBrokersMissingPaymentsQueryKey: [],
  actionsVisibilityOverrides: {
    silence: true,
    resolve: true,
    openInNewTab: true,
  },
  createOrEditNAVItemOptions: {
    isOpen: false,
    item: undefined,
  },
  setCreateOrEditNAVItemOptions: () => {},
})

export default NeedsAttentionContext
